// extracted by mini-css-extract-plugin
module.exports = {"title":"title-JDN8p","tooltip":"tooltip-23GLo","tooltip_arrow":"tooltip_arrow-3DK49","popper":"popper-3nJZn","tooltip_wrapper":"tooltip_wrapper-3L0Hk"};